import { render, staticRenderFns } from "./VDesignDataUpdateModal.vue?vue&type=template&id=286fc454&"
import script from "./VDesignDataUpdateModal.vue?vue&type=script&lang=ts&"
export * from "./VDesignDataUpdateModal.vue?vue&type=script&lang=ts&"
import style0 from "./VDesignDataUpdateModal.vue?vue&type=style&index=0&id=286fc454&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports